import React from "react"
import games from "../../../content/games.json"
import { Link } from "gatsby";

import "./gamesreview.scss"

class GameReview extends React.Component {
  render() {
    const { id } = this.props;

    const game = games.find(element => {
      return element.id === id;
    });

    return (
      <div className="game-info">
        <h2>Om {game.name}</h2>
        <div className="facts">
          <dl>
            <dt>
              Tillverkad av:
            </dt>
            <dd>
              <Link to={"/speltillverkare/" + game.speltillverkareLink} className="provider">{game.speltillverkare}</Link>
            </dd>
            <dt>Lanseringsår:</dt>
            <dd>{game.date}</dd>

            <dt>Spelplan:</dt>
            <dd>{game.spelplan}</dd>

            <dt>Vinstlinjer:</dt>
            <dd>{game.vinslinjer}</dd>

            <dt>RTP:</dt>
            <dd>{game.rtp}</dd>

            <dt>Volatilitet:</dt>
            <dd>{game.volatilitet}</dd>

            <dt>Maxvinst:</dt>
            <dd>{game.maxvinst}</dd>

            <dt>Bonusspel:</dt>
            <dd>{game.bonusspel}</dd>

            <dt>Min - max insats:</dt>
            <dd>{game.minmax}</dd>
          </dl>
        </div>
      </div>
    )
  }
}

export default GameReview